import { PERSONAL_INFO } from 'containers/SignupPages/constants';
import { fromJS } from 'immutable';
import { UserActionType } from 'store/user/actions';
import {
  GET_USER_INFO,
  GET_USER_INFO_FAIL,
  GET_USER_INFO_SUCCESS,
  LOGIN_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  SET_IS_USER_FOUND,
  SET_LOGIN,
  SET_NOTIFICATIONS,
  SET_NOTIFICATION_READ_SUCCESS,
  SET_PIN_ID,
  SET_PROFILE_SETTINGS_INFO,
  SET_ROLES,
  SET_SIGNUP_STEP,
  SET_TOKEN,
  SET_USER_INFO,
  SUBMIT_SIGNUP_STEP,
  SUBMIT_SIGNUP_STEP_FAIL,
  SUBMIT_SIGNUP_STEP_SUCCESS,
  UPDATE_PROFILE_SETTINGS_INFO,
  UPDATE_PROFILE_SETTINGS_INFO_FAIL,
  UPDATE_PROFILE_SETTINGS_INFO_SUCCESS,
  SET_IDENTITY_IMAGES,
  SET_EMAIL,
  SET_LOGIN_RECOVERY,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
} from 'store/user/constants';
import { CONTRACT_TYPE } from 'utils/globalConst';

export const initialState = fromJS({
  login: '',
  firstName: '',
  lastName: '',
  bday: '',
  phone: '',
  cin: '',
  drpp: '',
  email: '',
  roles: [],
  notifications: [],
  isLoginLoading: false,
  isLogoutLoading: false,
  errorMessage: null,
  currentSignupStepName: PERSONAL_INFO,
  isLoading: false,
  token: '',
  pinId: '',
  isUserFound: false,
  isNotifEnabled: false,
  language: '',
  isUpdateProfileSettingsLoading: false,
  isGetUserInfoLoading: false,
  identityImages: {},
  contractType: CONTRACT_TYPE.other,
});

const NOTIFICATION = 'notifications';

export default function reducer(state = initialState, action: UserActionType) {
  switch (action.type) {
    case SET_USER_INFO:
      return state.merge(action.payload);

    case SET_TOKEN:
      return state.merge({ token: action.payload }, { isLoading: false });
    case SET_EMAIL:
      return state.merge({ email: action.payload });

    case LOGIN_REQUEST:
      return state.set('isLoginLoading', true).set('errorMessage', null);

    case LOGIN_SUCCESS:
      return state.merge(action.payload, { isLoginLoading: false });

    case LOGIN_FAIL:
      return state
        .set('isLoginLoading', false)
        .set('errorMessage', action.payload);

    case LOGOUT_REQUEST:
      return state.set('isLogoutLoading', true).set('errorMessage', null);

    case LOGOUT_SUCCESS:
      return state.merge({ isLogoutLoading: false });

    case LOGOUT_FAIL:
      return state
        .set('isLogoutLoading', false)
        .set('errorMessage', action.payload);

    case SUBMIT_SIGNUP_STEP:
      return state.set('isLoading', true);

    case SUBMIT_SIGNUP_STEP_SUCCESS:
      return state.merge(action.payload, { isLoading: false });

    case SUBMIT_SIGNUP_STEP_FAIL:
      return state.set('isLoading', false).set('errorMessage', action.payload);

    case SET_SIGNUP_STEP:
      return state
        .set('currentSignupStepName', action.payload)
        .set('isLoading', false);

    case SET_PIN_ID:
      return state.set('pinId', action.payload);
    case SET_LOGIN:
      return state.set('login', action.payload);
    case SET_IS_USER_FOUND:
      return state.set('isUserFound', true);
    case SET_ROLES:
      return state.set('roles', action.payload);
    case SET_LOGIN_RECOVERY:
      return state.set('login', action.payload);
    case SET_NOTIFICATIONS:
      return state.set(NOTIFICATION, action.payload);
    case SET_NOTIFICATION_READ_SUCCESS: {
      const notifications = state.get(NOTIFICATION);
      const groupIndex = notifications.findIndex(
        (e: any) => e.month === action.payload.group,
      );
      const notificationIndex = notifications[
        groupIndex
      ].notifications.findIndex((e: any) => e.id === action.payload.id);

      return state.updateIn(
        [NOTIFICATION, groupIndex, NOTIFICATION, notificationIndex, 'read'],
        (v: boolean) => !v,
      );
    }

    case SET_PROFILE_SETTINGS_INFO:
      return state.merge(action.payload);

    case UPDATE_PROFILE_SETTINGS_INFO:
      return state.set('isUpdateProfileSettingsLoading', true);
    case UPDATE_PROFILE_SETTINGS_INFO_SUCCESS:
      return state.set('isUpdateProfileSettingsLoading', false);
    case UPDATE_PROFILE_SETTINGS_INFO_FAIL:
      return state.set('isUpdateProfileSettingsLoading', false);

    case GET_USER_INFO:
      return state.set('isGetUserInfoLoading', true);
    case GET_USER_INFO_SUCCESS:
      return state.merge({ isGetUserInfoLoading: false, ...action.payload });
    case GET_USER_INFO_FAIL:
      return state.set('isGetUserInfoLoading', false);

    case SET_IDENTITY_IMAGES:
      return state.set('identityImages', action.payload);

    default:
      return state;
  }
}
